module.exports = __webpack_public_path__ + "static/media/NotFound.68b1cecd.jpg";